
import { Component, Vue } from 'vue-property-decorator';
import Layout from '@/layouts/Default.vue';
import ListBlock from '@/views/CRUD/List.vue';

import StoriesModule from '@/store/stories';

@Component({
    components: {
        Layout,
        ListBlock,
    },
})
export default class HomePage extends Vue {
    repository = StoriesModule;

    get filterSettings() {
        return StoriesModule.filter.filterSettings;
    }

    toAdd() {
        this.$router.push({ name: 'stories_create' });
    }

    async updateList() {
        await StoriesModule.filter.updateFilter();
        await StoriesModule.getList();
    }

    async resetFilters() {
        await StoriesModule.clearSort();
        await StoriesModule.filter.resetFilter();
        await StoriesModule.getList();
    }
}
